module.exports = __webpack_public_path__ + "static/media/green_bike.063b303a.png";